module.exports = __webpack_public_path__ + "./SharpayPhoto_01771037f0235722e67c4bcbdde34db0.png";


//////////////////
// WEBPACK FOOTER
// ./src/static/images/sectionTalking/2019/SharpayPhoto.png
// module id = 489
// module chunks = 0